import React from 'react'
import IFrameFullscreen from '../indicators/components/fullscreen/iframe-fullscreen.component'
import { iframeOptions } from '../../consts/navigation.conts'

const GeoportalPage = () => {
  return (
    <IFrameFullscreen
      link={iframeOptions['geoportal'].link}
      title={iframeOptions['geoportal'].title}
      noClose
    />
  )
}

export default GeoportalPage